import styled, { css } from 'styled-components';
import tw from 'twin.macro';

export const FieldContainer = styled.div<{
  isRequired: boolean;
  isMarginBottomZero: boolean;
}>`
  ${tw`w-full relative`}
  ${(props) => (props.isMarginBottomZero ? tw`mb-0` : tw`mb-1`)};
  .getOTPFieldButtonClassName {
    height: 36px;
    width: 108px;
    margin-left: 8px;
    margin-bottom: 10px;

    * {
      pointer-events: none;
    }

    @media (max-width: 580px) {
      margin-left: 0px;
      margin-bottom: 12px;
      width: 100%;
    }
  }

  .product-promotional-code-apply-button {
    height: 36px;
    width: 112px;
    margin-left: 8px;
    margin-bottom: -4px;
    * {
      pointer-events: none;
    }

    @media (max-width: 580px) {
      margin-left: 0px;
      margin-bottom: 12px;
      width: 100%;
    }
  }

  .hideEditButtonClassName {
    display: none !important;
  }
  ${(props) => props.css};
`;

export const RequiredAsteriskStyles = css`
  .informedInputLabelText::after {
    content: '*';
    color: red;
  }
`;

export const fileUploaderLabelTextCSS = css`
  ::after {
    content: '*';
    color: red;
  }
`;

export const inputFieldMarginStyle = css`
  margin-bottom: 0px;
  position: relative;
`;

export const checkBoxFieldWrapperStyles = css`
  ${tw`mb-3`};
  @media (max-width: 1023px) {
    ${tw`mb-1`};
  }
`;

export const OTPContainerStyles = css`
  ${tw`mb-0`}
  @media (max-width: 1299px) {
    ${tw`mt-3`}
  }
`;

export const OtpBoxesContainerStyles = css`
  ${tw`flex justify-between `}
`;

export const OTPBoxesFieldContainerStyles = css`
  align-self: flex-start;
  width: 100%;
`;

export const errorMessageStyles = css`
  ${tw`text-center w-full text-left flex-wrap`};
`;

export const labelStyles = css`
  ${tw`font-inter text-sm leading-5 font-medium mb-2 w-full`}
  color: #334155;
`;

export const radioGroupfieldWrapperStyles = css`
  ${tw`mb-0`}
`;

export const radioWrapperStyles = css`
  ${tw`flex flex-col flex-wrap ml-0 justify-between`};
`;

export const GetOtpButtonText = styled.span`
  font-family: Inter;
  letter-spacing: 0.2px;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  color: white;
  font-weight: normal;
  @media (min-width: 1300px) {
    font-weight: 500;
  }
`;

export const ContentFieldContainer = styled.div`
  ${tw`font-inter text-base  leading-5 font-medium w-full mb-6 leading-6`}
  display: ${(props) => (props.isHidden ? 'none' : 'flex')};
  color: #334155;
  a {
    color: #0967d2;
  }
`;

export const FormFieldGroupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 24px;
`;

export const omegaDatePickerContainerCSS = css`
  .react-datepicker__header.react-datepicker__header {
    background-color: transparent !important;
    padding: 0 !important;
  }

  .react-datepicker__day {
    padding-top: 3px !important;
  }

  .customizedDayClassName {
    color: #334155 !important;
  }

  .customizedSelectedDayClassName {
    color: #ffffff !important;
  }

  .customizedDayDisabledClassName {
    color: #94a3b8 !important ;
  }
`;

export const OtpButtonAndPhoneNumberWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  @media (max-width: 580px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 12px;
    .phoneNumberFieldHelperTextClassName {
      height: fit-content !important;
    }
  }
`;

export const ProductPromotionalCodesFieldAndButtonWrapper = styled(
  OtpButtonAndPhoneNumberWrapper
)``;

export const SuccessInviteAndCouponCodeMessage = styled.span`
  ${tw`text-sm block min-h-22px`};
  color: rgb(106, 168, 79);
  font-family: 'Inter';
`;
